import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import FollowButton from '../Components/FollowButton'
import CollapsingHeader from '../Components/CollapsingHeader'
import { useRail } from '../Components/Layout'
import SortedFeed, { useSortParam } from '../Components/SortedFeed'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { saveRecentSearch } from '../Hooks/useSearch'
import { t } from '../i18n'
import { api } from '../Services/api'
import { useFollow } from '../State/Follow'

/* "Sve vijesti za X": stories matching the words, with "+ Prati" to keep the
   words as one of Moje teme. */
export default function SearchResults() {
  const [params] = useSearchParams()
  const query = (params.get('q') || '').replace(/\s+/g, ' ').trim()
  const [sort, setSort] = useSortParam()
  const { sources: followed } = useFollow()
  const feed = useFeed(
    `search:${query.toLowerCase()}:${sort}:${followed.join(',')}`,
    ({ cursor, refresh }) => api.searchStories(query, { sort, cursor, followed, refresh }),
    { enabled: query.length >= 2, eventProps: { chip: sort, sort } }
  )
  useDocumentTitle(query || null)
  useRail({ ad: 'search' })
  useEffect(() => {
    if (query.length < 2) return
    saveRecentSearch(query)
  }, [query])
  // Search results aren't pages of their own (spec 9.9); the server sends the
  // same tag when /pretraga is opened directly.
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, follow'
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [])

  if (query.length < 2) return <Navigate to="/istrazi" replace />
  const label = feed.extra.query || query
  return (
    <>
      <CollapsingHeader
        title={label}
        action={
          <FollowButton kind="keyword" item={{ title: label }} variant="header" entry="search" />
        }
        compactAction={
          <FollowButton
            kind="keyword"
            item={{ title: label }}
            variant="header"
            entry="search"
            small
          />
        }
      />
      <SortedFeed
        feed={feed}
        sort={sort}
        setSort={setSort}
        adSurface="search"
        empty={<p>{t('myTopics.noNews')}</p>}
      />
    </>
  )
}
